export default (opts = {}) => {
  const component = {
    model: {
      defaults: {
        tagname: 'div',
        name: "Colunas Blog",
        attributes: { class: 'flex sm-flex-col gap-20' },
        components: [
          {
            type: 'itemBlog3'
          },
          {
            type: 'itemBlog3'
          },
        ],
        styles: `
        .flex{
          display: flex; 
        }
        .gap-20{
          gap: 20px; 
        }
        
        @media (max-width: 992px){
          .sm-flex-col{
            flex-direction: column; 
          }
        }
      `,
      },
    },
    view: {

    },
  };

  return component;
};
